import React from 'react';
import styled from '@emotion/styled';
import TableCheckbox from 'components/Form/TableCheckbox';
import { getSafeValue } from '../../../utils/security';
import { StyledInfoEllipsis } from '../../Wizard/Global/WizardStyled';
import { StyledAction } from '../StyledComponents';
import Checkbox from '../../Form/Checkbox';
import { StyledContrastPanelColumn } from '../../Wizard/Global/WizardStyledContrastPanel';

const RowFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const SingleActionSetting = ({
  setting,
  mapSettings,
  mapSettingsPanel,
  handleOnSwitchChange,
  useTableCheckbox,
}) => {
  const settingVal = getSafeValue(mapSettings, setting.value);
  const checked = settingVal === null || settingVal?.enabled === false ? false : settingVal;
  const id =
    setting.value === 'hidePositions'
      ? 'positions'
      : setting.value === 'hideMaxTimeOnVehicle'
      ? 'maxTimeOnVehicle'
      : setting.value === 'hideGroups'
      ? 'groups'
      : setting.value === 'hidePriority'
      ? 'priority'
      : setting.value;

  return (
    <StyledContrastPanelColumn id={id} key={id} actionsCount={2} inputSize="XS" isEnabled={checked}>
      {useTableCheckbox ? (
        <RowFlex>
          <TableCheckbox
            total={1}
            selected={checked ? 1 : 0}
            onSelect={() => handleOnSwitchChange(setting.value, true)}
            onUnselect={() => handleOnSwitchChange(setting.value, false)}
            title=""
            whiteLabel
          />
          <StyledInfoEllipsis
            alt={getSafeValue(mapSettingsPanel, setting.value)}
            title={getSafeValue(mapSettingsPanel, setting.value)}
            hasMarginTop
          >
            {getSafeValue(mapSettingsPanel, setting.value)}
          </StyledInfoEllipsis>
        </RowFlex>
      ) : (
        <>
          <StyledInfoEllipsis
            alt={getSafeValue(mapSettingsPanel, setting.value)}
            title={getSafeValue(mapSettingsPanel, setting.value)}
            hasMarginTop
          >
            {getSafeValue(mapSettingsPanel, setting.value)}
          </StyledInfoEllipsis>
          <StyledAction>
            <Checkbox
              id={`mapSettingsCheckbox-${setting.value}`}
              value={checked}
              contrast
              onChange={(value) => handleOnSwitchChange(setting.value, value)}
            />
          </StyledAction>
        </>
      )}
    </StyledContrastPanelColumn>
  );
};

export default SingleActionSetting;
